module.exports = __webpack_public_path__ + "img/1.05.a6189b6d.jpg";